import { useEffect, useMemo, useState } from 'react';

import throttle from 'lodash/throttle';

interface IWindowSize {
  width: number;
  height: number;
}

interface IUseViewportSizing {
  windowSize: IWindowSize;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isNormalDesktop: boolean;
  isMediumDesktop: boolean;
}

const getWindowSize = (): IWindowSize => ({
  width: window.innerWidth,
  height: window.innerHeight,
});

export default function useViewportSizing(): IUseViewportSizing {
  const [windowSize, setWindowSize] = useState<IWindowSize>(getWindowSize);

  const isMobile = useMemo(() => windowSize.width < 768, [windowSize.width]);
  const isTablet = useMemo(() => windowSize.width >= 768 && windowSize.width < 992, [windowSize.width]);
  const isDesktop = useMemo(() => windowSize.width >= 992, [windowSize.width]);
  const isNormalDesktop = useMemo(() => windowSize.width >= 1200, [windowSize.width]);
  const isMediumDesktop = useMemo(() => windowSize.width >= 1200 && windowSize.width < 1400, [windowSize.width]);

  useEffect(() => {
    const handleResize = throttle(() => {
      setWindowSize(getWindowSize());
    }, 200);

    window.addEventListener('resize', handleResize);

    return () => {
      handleResize.cancel();
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    windowSize,
    isMobile,
    isTablet,
    isDesktop,
    isNormalDesktop,
    isMediumDesktop,
  };
}
